// Default values for the calculator
const DEFAULT_VALUES = {
    workforce: 1000,
    hoursSaved: 1,
    wage: 75,
    duration: 12
};

function resetCalculator() {
    // Reset all input fields to default values
    document.getElementById('workforce').value = DEFAULT_VALUES.workforce;
    document.getElementById('hoursSaved').value = DEFAULT_VALUES.hoursSaved;
    document.getElementById('wage').value = DEFAULT_VALUES.wage;
    document.getElementById('duration').value = DEFAULT_VALUES.duration;
    
    // Recalculate with default values
    calculate();
}

// Add event listener for reset button
document.getElementById('reset-safety').addEventListener('click', resetCalculator);

// Baseline ratios from eBook (1,000 workers baseline)
// Traditional model costs per 1,000 workers annually
const BASELINE_WORKFORCE = 1000;
const BASELINE_DOWNTIME_TRAD = 75000;
const BASELINE_TESTING_TRAD = 500000;
const BASELINE_ADMIN_TRAD = 30000;
const BASELINE_EMR_TRAD = 40000;
const BASELINE_TOTAL_TRAD = 645000;

// OnPoint model costs per 1,000 workers annually
const BASELINE_DOWNTIME_ONPOINT = 37500;
const BASELINE_TESTING_ONPOINT = 62500;
const BASELINE_ADMIN_ONPOINT = 15000;
const BASELINE_EMR_ONPOINT = 10000;
const BASELINE_TOTAL_ONPOINT = 125000;

function formatCurrency(num) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(num);
}

function calculate() {
    const workforce = parseInt(document.getElementById('workforce').value) || 0;
    const hoursSavedPerWeek = parseFloat(document.getElementById('hoursSaved').value) || 0;
    const wage = parseInt(document.getElementById('wage').value) || 0;
    const duration = parseInt(document.getElementById('duration').value) || 12;

    // Calculate scaling factor based on workforce
    const workforceScale = workforce / BASELINE_WORKFORCE;

    const wageScale = wage / 75; // Baseline assumes $75/hour

    const hoursScale = hoursSavedPerWeek / 1; // Baseline assumes 1 hour/week saved

    // Calculate annual hours saved
    const annualHoursSaved = workforce * hoursSavedPerWeek * 52;
    const fte = annualHoursSaved / 2080;

    // Scale costs proportionally to workforce size
    // Traditional model
    const downtimeTrad = BASELINE_DOWNTIME_TRAD * workforceScale * wageScale * hoursScale;
    const testingTrad = BASELINE_TESTING_TRAD * workforceScale * hoursScale;
    const adminTrad = BASELINE_ADMIN_TRAD * workforceScale * hoursScale;
    const emrTrad = BASELINE_EMR_TRAD * workforceScale * hoursScale;
    const totalTrad = downtimeTrad + testingTrad + adminTrad + emrTrad;

    // OnPoint model
    const downtimeOnPoint = BASELINE_DOWNTIME_ONPOINT * workforceScale * wageScale * hoursScale;
    const testingOnPoint = BASELINE_TESTING_ONPOINT * workforceScale * hoursScale;
    const adminOnPoint = BASELINE_ADMIN_ONPOINT * workforceScale * hoursScale;
    const emrOnPoint = BASELINE_EMR_ONPOINT * workforceScale * hoursScale;
    const totalOnPoint = downtimeOnPoint + testingOnPoint + adminOnPoint + emrOnPoint;

    // Adjust for project duration (if less than 12 months)
    const durationMultiplier = duration / 12;
    const adjustedTotalTrad = totalTrad * durationMultiplier;
    const adjustedTotalOnPoint = totalOnPoint * durationMultiplier;

    // Calculate savings
    const totalSavings = adjustedTotalTrad - adjustedTotalOnPoint;
    const roiPercentage = ((totalSavings / adjustedTotalOnPoint) * 100);
    const paybackMonths = adjustedTotalOnPoint / (totalSavings / duration);

    // Update detailed breakdown
    document.getElementById('downtimeTrad').textContent = formatCurrency(downtimeTrad * durationMultiplier);
    document.getElementById('downtimeOnPoint').textContent = formatCurrency(downtimeOnPoint * durationMultiplier);
    
    document.getElementById('testingTrad').textContent = formatCurrency(testingTrad * durationMultiplier);
    document.getElementById('testingOnPoint').textContent = formatCurrency(testingOnPoint * durationMultiplier);
    
    document.getElementById('adminTrad').textContent = formatCurrency(adminTrad * durationMultiplier);
    document.getElementById('adminOnPoint').textContent = formatCurrency(adminOnPoint * durationMultiplier);
    
    document.getElementById('emrTrad').textContent = formatCurrency(emrTrad * durationMultiplier);
    document.getElementById('emrOnPoint').textContent = formatCurrency(emrOnPoint * durationMultiplier);

    // Update summary
    document.getElementById('totalSavings').textContent = formatCurrency(totalSavings);
    document.getElementById('roi').textContent = roiPercentage.toFixed(0) + '%';
    document.getElementById('payback').textContent = paybackMonths.toFixed(1) + ' mo';
    document.getElementById('hours').textContent = annualHoursSaved.toLocaleString() + ' hours';
    document.getElementById('fte').textContent = '= ' + fte.toFixed(1) + ' full-time employees';
    document.getElementById('traditional').textContent = formatCurrency(adjustedTotalTrad);
    document.getElementById('onpoint').textContent = formatCurrency(adjustedTotalOnPoint);
    document.getElementById('savings').textContent = formatCurrency(totalSavings);
}

// Add event listeners
['workforce', 'hoursSaved', 'wage', 'duration'].forEach(id => {
    document.getElementById(id).addEventListener('input', calculate);
});

// Initial calculation
calculate();